var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.percentBarClass]},[_c('div',{staticClass:"percentBarInner",class:[_vm.genderTypeClass, _vm.percentBarInnerClass],style:(_vm.percentStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }